import React from 'react';

// The row of headline figures above every report. Items: { label, value, sub?, tone? }.
// tone 'alert' turns the value rose - used for refunds, outstanding amounts, critical stock.
const KpiStrip = ({ items, loading = false }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
    {items.map((item, i) => (
      <div key={i} role="group" aria-label={item.label} className="bg-white rounded-2xl shadow p-4">
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide truncate" title={item.label}>
          {item.label}
        </p>
        {loading ? (
          <div className="mt-2 h-7 w-20 bg-gray-200 rounded animate-pulse" />
        ) : (
          <p
            className={`mt-1 text-xl font-bold truncate ${
              item.tone === 'alert' ? 'text-rose-600' : 'text-gray-900'
            }`}
            title={String(item.value ?? '—')}
          >
            {item.value ?? '—'}
          </p>
        )}
        {!loading && item.sub && <p className="text-[11px] text-gray-500 truncate" title={item.sub}>{item.sub}</p>}
      </div>
    ))}
  </div>
);

export default KpiStrip;
